import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes } from '../../components/foundations/Icon';
import ChatInput from './ChatInput';
import SingularLogo from '../../resources/svg/singular_logo_blue_figma.svg';
import css from './ChatEmptyState.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.EMPTY_STATE';

const SUGGESTIONS = [
    { id: 1, queryKey: 'COMPARE_PERFORMANCE', icon: 'chart-bar', iconColor: 'var(--blue300)' },
    { id: 2, queryKey: 'SUMMARIZE_ACTIVITY', icon: 'file-text-spark', iconColor: 'var(--blue300)' },
    { id: 3, queryKey: 'EXPLAIN_DECREASE', icon: 'chart-histogram', iconColor: 'var(--blue300)' },
    { id: 4, queryKey: 'BUILD_DASHBOARD', icon: 'layout-dashboard', iconColor: 'var(--blue300)' },
];

const ChatEmptyState = ({
    onSuggestionClick,
    input,
    handleInputChange,
    handleSubmit,
    isLoading,
    stop,
    onMicClick,
    isMicListening,
    micSupported,
    translate,
}) => {
    return (
        <div className={css.chatEmptyState}>
            <div className={css.greetingSection}>
                <SingularLogo className={css.greetingLogo} />
                <div className={css.greetingTitle}>{translate(`${TRANSLATION_PREFIX}.GREETING_TITLE`)}</div>
            </div>

            <div className={css.chatInputWrapper}>
                <ChatInput
                    input={input}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                    isLoading={isLoading}
                    stop={stop}
                    onMicClick={onMicClick}
                    isMicListening={isMicListening}
                    micSupported={micSupported}
                    containerClassName={css.chatInputInEmptyState}
                />
            </div>

            <div className={css.suggestionsGrid}>
                {SUGGESTIONS.map(({ id, queryKey, icon, iconColor }) => {
                    const query = translate(`${TRANSLATION_PREFIX}.SUGGESTIONS.${queryKey}`);
                    return (
                        <button
                            type="button"
                            key={id}
                            onClick={() => onSuggestionClick(query)}
                            className={css.suggestionCard}
                        >
                            <Icon
                                name={icon}
                                type={IconTypes.TABLER}
                                size={IconSizes.SMALL}
                                style={{ color: iconColor }}
                            />
                            <div className={css.suggestionText}>{query}</div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

ChatEmptyState.propTypes = {
    onSuggestionClick: PropTypes.func.isRequired,
    input: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    stop: PropTypes.func.isRequired,
    onMicClick: PropTypes.func,
    isMicListening: PropTypes.bool,
    micSupported: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ChatEmptyState);
